import { Group, Text, ActionIcon, Tooltip } from '@mantine/core';
import { IconArrowsDiagonal, IconArrowsDiagonalMinimize2, IconNote } from '@tabler/icons-react';
import { ExportButton } from '@/components/common/ExportButton';
import type { RefObject } from 'react';

interface ChartHeaderProps {
  title: string;
  subtitle?: string;
  chartRef: RefObject<HTMLDivElement | null>;
  expanded?: boolean;
  onToggle?: () => void;
  onAddNote?: () => void;
}

export function ChartHeader({ title, subtitle, chartRef, expanded, onToggle, onAddNote }: ChartHeaderProps) {
  return (
    <Group justify="space-between" align="center" mb="xs">
      <Group gap="xs" align="baseline">
        <Text fw={600} style={{ fontFamily: 'Space Grotesk, sans-serif', fontSize: 18 }}>{title}</Text>
        {subtitle && <Text size="xs" c="dimmed">{subtitle}</Text>}
      </Group>
      <Group gap={4}>
        {onAddNote && (
          <Tooltip label="Add note" withArrow>
            <ActionIcon
              variant="subtle"
              color="gray"
              size="sm"
              onClick={onAddNote}
              aria-label="Add note to chart"
            >
              <IconNote size={16} />
            </ActionIcon>
          </Tooltip>
        )}
        {onToggle && (
          <Tooltip label={expanded ? 'Collapse' : 'Expand'} withArrow>
            <ActionIcon
              variant="subtle"
              color="gray"
              size="sm"
              onClick={onToggle}
              visibleFrom="lg"
              aria-label={expanded ? 'Collapse chart' : 'Expand chart'}
            >
              {expanded ? <IconArrowsDiagonalMinimize2 size={16} /> : <IconArrowsDiagonal size={16} />}
            </ActionIcon>
          </Tooltip>
        )}
        <ExportButton targetRef={chartRef} chartName={title} />
      </Group>
    </Group>
  );
}
